
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/cart",
      function () {
        return require("private-next-pages/[region]/[lang]/cart.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/cart"])
      });
    }
  